import type { Store } from './store';

import { PlayerWidgetState } from '../widgets/playerWidget/playerWidgetState';
import { PlayerWidgetInjector } from '../widgets/playerWidget/playerWidgetInjector';
import { UploadWidgetState } from '../widgets/uploadWidget/uploadWidgetState';
import { UploadCompactWidgetState } from '../widgets/uploadWidget/uploadCompactWidgetState';
import { UploadWidgetInjector } from '../widgets/uploadWidget/uploadWidgetInjector';
import { TeamWidgetState } from '../widgets/teamWidget/teamWidgetState';
import { TeamWidgetInjector } from '../widgets/teamWidget/teamWidgetInjector';
import { LiveStreamQueueWidgetState } from '../widgets/liveStreamQueueWidget/liveStreamQueueWidgetState';
import { LiveStreamQueueWidgetInjector } from '../widgets/liveStreamQueueWidget/liveStreamQueueWidgetInjector';
import { AnalyticsWidgetState } from '../widgets/analyticsWidget/analyticsWidgetState';
import { AnalyticsWidgetInjector } from '../widgets/analyticsWidget/analyticsWidgetInjector';

export function createWidgetStores(store: Store) {
  return {
    playerWidget: new PlayerWidgetState(store),
    playerWidgetInjector: new PlayerWidgetInjector(store),
    uploadWidget: new UploadWidgetState(store),
    uploadCompactWidget: new UploadCompactWidgetState(store),
    uploadWidgetInjector: new UploadWidgetInjector(store),
    teamLibraryWidget: new TeamWidgetState(store),
    teamWidgetInjector: new TeamWidgetInjector(store),
    liveStreamQueueWidget: new LiveStreamQueueWidgetState(store),
    liveStreamQueueWidgetInjector: new LiveStreamQueueWidgetInjector(store),
    analyticsWidget: new AnalyticsWidgetState(store),
    analyticsWidgetInjector: new AnalyticsWidgetInjector(store),
  };
}

export type WidgetStores = ReturnType<typeof createWidgetStores>;
